// src/store/index.js
import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // Uses localStorage for web
import rootReducer from './reducers';

// Configure persist options
const persistConfig = {
  key: 'root', 
  storage,
  whitelist: ['appreducer'], 
};

// Wrap the root reducers with a persist function
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create the store
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'], // Ignore Redux Persist actions
      },
    }),
});

// Create the persistor
const persistor = persistStore(store);

export { store, persistor };
